
(function () {
  function inspect() {
    var productForm = document.querySelector(
      'form[action*="/cart/add"]'
    );

    var productInfo = document.querySelector(
      'product-info'
    );

    var mainContent = document.querySelector(
      '#MainContent'
    );

    return {
      readyState: document.readyState,
      productFormPresent: Boolean(productForm),
      productInfoPresent: Boolean(productInfo),
      mainContentPresent: Boolean(mainContent),
      productFormCount: document.querySelectorAll(
        'form[action*="/cart/add"]'
      ).length
    };
  }

  window.siteDiagnostics = {
    inspect: inspect
  };

  document.documentElement.dataset.runtimeReady = 'true';
})();
